import { useQuery } from "@tanstack/react-query";
import axiosManager from "services/axiosManager";

const useGetParent = () => {
    const {
        data: parent,
        error,
        isLoading,
    } = useQuery({
        queryKey: ["parent"],
        queryFn: () => axiosManager.get$("/parent").then((res) => res.data),
    });

    return { parent, error, isLoading };
};

export default useGetParent;
